import React from 'react';

import { Link } from '@zola/zola-ui';

const actionLabel = ({ labelText, buttonText, onClick }) => (
  <>
    <span>{labelText}</span>
    <Link role="button" onClick={onClick} arrow>
      {buttonText}
    </Link>
  </>
);

// labels with links:
export const LocationLabel = ({ onClick }) =>
  actionLabel({
    labelText: 'Event Location',
    buttonText: 'Enter Address Manually',
    onClick,
  });

// EventFormV2.jsx #127
export const AutoLocationNoIdLabel = ({ onClick }) =>
  actionLabel({
    labelText: 'Venue Name',
    buttonText: 'Search For Location',
    onClick,
  });

export const AutoLocationLabel = ({ onClick }) =>
  actionLabel({
    labelText: 'Venue Name',
    buttonText: 'Reset Address',
    onClick,
  });

export const AttireLabel = ({ onClick }) =>
  actionLabel({
    labelText: 'Attire Suggestions',
    buttonText: 'See Common Attire Suggestions',
    onClick,
  });

export const QuestionsLabel = ({ onClick }) =>
  actionLabel({
    labelText: 'Ask Other RSVP Questions',
    buttonText: 'See Common RSVP Questions',
    onClick,
  });



// WEBPACK FOOTER //
// ./src/pages/Events/FormBody/components/FieldLabels/FieldLabels.jsx